import React from "react";
import { Box, Button, Icon, Modal, Typography } from "@bca/ui-library";

import Spinner from "../Spinner";

interface DeleteProxyBidConfirmationModalProps {
  isOpen: boolean;
  isProxyBidsDataLoading: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteProxyBidConfirmationModal: React.FunctionComponent<
  DeleteProxyBidConfirmationModalProps
> = ({ isOpen, isProxyBidsDataLoading, onClose, onConfirm }) => {
  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      onClose={onClose}
      aria-label="delete-proxy-bid"
      overlayVariant="dark"
      showXButton={false}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        minWidth={{ mobile: "260px", tablet: "300px", desktop: "640px" }}
        paddingX={{ mobile: 0, tablet: 0, desktop: "40px" }}
      >
        <Icon
          name="exclamation-triangle"
          color="black"
          width="62px"
          height="55px"
        />
        <Typography
          variant="h4"
          color="footer-blue"
          textAlign="center"
          mt={6}
          mb={3}
        >
          You are about to delete your proxy bid
        </Typography>
        <Typography
          variant="body-lg"
          color="grey-blue"
          textAlign="center"
          mb={9}
          mt={0}
          css={`
            max-width: 540px;
          `}
        >
          By pressing Confirm, your proxy bid will be deleted.
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        mt={24}
      >
        <Button
          variant="secondary"
          height="42px"
          width={{ mobile: "120px", tablet: "122px", desktop: "122px" }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant="primary-gradient"
          height="42px"
          width={{ mobile: "120px", tablet: "122px", desktop: "122px" }}
          onClick={onConfirm}
        >
          {isProxyBidsDataLoading ? <Spinner /> : "Confirm"}
        </Button>
      </Box>
    </Modal>
  );
};

export default DeleteProxyBidConfirmationModal;
